import React, {Component} from 'react';
import classnames from 'classnames';
import autobind from 'autobind-decorator'
import { DragLayer } from 'react-dnd'
import If from "../common/control/If";

@DragLayer(monitor => ({
    item: monitor.getItem(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
}))
class DragNode extends Component {
    constructor(props) {
        super(props);
        this.renderCount = 0;
    }

    makeStyle() {
        const { currentOffset } = this.props;
        if (!currentOffset) {
            return {
                display: 'none'
            };
        }

        let { x, y } = currentOffset;

        const transform = `translate(${x}px, ${y}px)`;
        return {
            display: 'block',
            position: 'fixed',
            WebkitTransform: transform,
            transform,
            top:0,
            left:0,
        };
    }

    renderChildren(category) {

        let smallLabel = '0';

        if(category.entries && category.entries > 0) {
            const reg = /(^[+-]?\d+)(\d{3})/;
            smallLabel = category.entries + '';
            while (reg.test(smallLabel)) smallLabel = smallLabel.replace(reg, '$1' + ',' + '$2');
        }

        if(category.children && category.children.length)
            return (<div className="list_sub">
                {category.children.map((child) => {
                    return (
                        <div key={child.id} className="bundle_item">
                            <div className="item_order" ref="inner" >
                                <div className="basic_item">
                                    <div className="wrap_drag">
                                        <span className="ico_blog ico_drag"/>
                                    </div>
                                    <div style={{display:'inline'}}>
                                        <div className="wrap_name">
                                            <span className="txt_name">{category.name}</span>
                                            <span className="txt_count">({smallLabel})</span>
                                        </div>
                                        { this.displayViewChannelLabel(child.viewChannel) }
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>);
        else
            return null;
    }

    render() {

        const { isDragging } = this.props;

        if (!isDragging) {
            return null
        }

        const category = this.props.item.category;
        const hasChild = category.hasOwnProperty('children') && category.children && (category.children.length > 0);

        const layerStyles = {
            display: 'block',
            position: 'relative',
            pointerEvents: 'none',
            zIndex: 100000,
            left: 0,
            top: 0,
        };

        let smallLabel = '0';

        if(category.entries && category.entries > 0) {
            const reg = /(^[+-]?\d+)(\d{3})/;
            smallLabel = category.entries + '';
            while (reg.test(smallLabel)) smallLabel = smallLabel.replace(reg, '$1' + ',' + '$2');
        }

        return (
            <div style={layerStyles}>
            <div className="item_drag" style={this.makeStyle()}>
                <div className={classnames('bundle_item', {
                    'open_subcate' : category.opened,
                })} >
                    <div className="item_order" ref="inner" >
                        <If condition={(category.depth === 1)}>
                            <label className={classnames("lab_btn lab_cate", {'lab_fold' : hasChild})}>
                                <span className="wrap_arr">
                                    <span className="ico_blog"/>
                                </span>
                                <input type="button" className="btn_g" value="open sub category"/>
                            </label>
                        </If>
                        <div className="basic_item">
                            <div className="wrap_drag">
                                <span className="ico_blog ico_drag"/>
                            </div>
                            <div style={{display:'inline'}}>
                                <div className="wrap_name">
                                    <span className="txt_name">{category.name}</span>
                                    <span className="txt_count">({smallLabel})</span>
                                </div>
                                { this.displayViewChannelLabel(category.viewChannel) }
                            </div>
                        </div>
                    </div>
                    <If condition={(hasChild && category.opened)}>
                        {this.renderChildren(category)}
                    </If>
                </div>
            </div>
            </div>
        );
    }

    displayViewChannelLabel(viewChannel) {

        if ( viewChannel ) {
            return <span className="txt_cate">{this.findViewChannelLabel(viewChannel)}</span>;
        }else {
            return null;
        }
    }

    findViewChannelLabel(id) {
        const { viewChannels } = this.props;

        for( let key in viewChannels) {
            let item = viewChannels[key];
            if(item.id === id){
                return item.label;
            }
            if(item.children && item.children.length > 0 ){
                for ( let subKey in item.children) {
                    let subItem = item.children[subKey];
                    if(subItem.id === id){
                        return subItem.label;
                    }
                }
            }
        }
    }

}

export default DragNode;
